<template>
    <div class="custom-tree-container">
        <el-row class="content-bottom-padded" style="padding-top:15px;margin-left:20px">
            <el-col>
                <el-button type="primary" icon="plus" @click="updateCategory" :disabled="isDisable">保存分类</el-button>
            </el-col>
        </el-row>
        <div class="block">
            <ul class="custom-tree-node-title">
                <li>分类名称</li>
                <li>分类排序</li>
                <li>图片</li>
                <li>推荐位显示</li>
                <li>推荐位排序</li>
                <li>前端展示</li>
                <li>是否禁用</li>
                <li>创建时间</li>
                <li>操作</li>
            </ul>
        </div>
        <div class="tree-background block">
            <el-tree v-loading="loading"
                     :data="categoryList"
                     default-expand-all
                     :expand-on-click-node="false">
                <ul class="custom-tree-node" slot-scope="{ node, data }">
                    <li>
                        <input placeholder="分类名称" v-model="data.category_name"/>
                        <el-button type="text" v-if="data.level < 1"
                                   @click="append(data.children, data.level)">新增分类
                        </el-button>
                    </li>
                    <li><input placeholder="分类排序" style="width: 65px;" v-model="data.sort"/></li>
                    <li class="category-icon">
                        <span @click="handleImgChange(data)">
                          <img v-if="data.image_url" :src="wximageurl + data.image_url"/>
                          <i v-else class="iconfont icon-image"></i>
                        </span>
                    </li>

                    <li>
                      <el-switch v-model="data.recommend"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchAuth(node, data)"></el-switch>
                    </li>
                    <li><input placeholder="排序" style="width: 65px;" v-model="data.recommend_sort" @change="editRecommendSort(node, data)"/></li>
                    <li>
                      <el-switch v-model="data.frontend_show"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchFrontendShow(node, data)"></el-switch>
                    </li>
                    <li>
                      <el-switch v-model="data.disabled"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchDisabled(node, data)"></el-switch>
                    </li>
                    <li v-if="data.created">{{ data.created | datetime }}</li>
                    <li v-else></li>
                    <li>
                        <router-link
                                :to="{path: matchInternalRoute('goodsphysical'), query:{category: data.category_id}}">
                            查看商品
                        </router-link>
                      <!-- <el-button type="text" @click="toDistributor(data.category_id)">批量同步到店铺</el-button> -->
                        <span class="remove-category" @click="deleteCategory(node, data)">
                          <i class="iconfont icon-trash-alt"></i>
                        </span>
                    </li>
                </ul>
            </el-tree>
          <!-- 商品批量同步到店铺  -->
          <SideBar :visible.sync="show_batchStore" title="分类批量同步到店铺" width="60">
            <div class="content-bottom-padded">
              <el-alert type="info" title="编辑提示" show-icon >
                <div>
                  如果输入店铺id(英克id)则店铺类型和区域类型无效。<br>
                  店铺类型和店铺区域不能同时选择<br>
                  店铺区域属于怡康自营门店和第三方门店无关
                </div>
              </el-alert>
            </div>
            <el-form label-position="left">
              <el-form-item label="分类id：">
                <el-row :gutter="10">
                  <el-col :span="10">
                    {{category_id}}
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="店铺类型： ">
                <el-row :gutter="10">
                  <el-col :span="10">
                    <el-select v-model="params.shop_type_id"   placeholder="选择店铺类型" style="width: 100%;">
                      <el-option
                        v-for="shop in shop_type_list_default"
                        :key="shop.shop_type_id"
                        :label="shop.shop_type_name"
                        :value="shop.shop_type_id">
                      </el-option>
                      <el-option
                        v-for="shop in shop_type_list"
                        :key="shop.shop_type_id"
                        :label="shop.shop_type_name"
                        :value="shop.shop_type_id">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="区域分类">
                <el-row :gutter="10">
                  <el-col :span="10">
                    <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                                 :options="new_office_area"
                                 :props="{ checkStrictly: true }"
                                 clearable>
                    </el-cascader>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="店铺id(多个店铺用英文逗号隔开)： ">
                <el-row :gutter="10">
                  <el-col :span="10">
                    <el-input type="textarea" v-model="districtId" placeholder="请填写店铺id"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item   style="margin:0 50%">
                <el-row :gutter="10">
                  <el-col :span="10">
                    <el-button type="primary" @click="saveSynsc" :loading="submitLoading">保存</el-button>
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </SideBar>
            <div class="add-category">
                <span @click="appendTop(categoryList)"><i class="el-icon-plus"></i>增加顶级分类</span>
            </div>
        </div>
        <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg"
                   @closeImgDialog="closeImgDialog"></imgPicker>

    </div>
</template>
<script>
import SideBar from '@/components/element/sideBar'
  import {getCategory, saveCategory, deleteCategory,updateCategory,saveToDistributor} from '@/api/goods';
  import imgPicker from '@/components/imageselect';
  import {getAreaManageList} from "@/api/areamanage";
  import {getShopTypes} from '@/api/marketing';

  export default {
    components: {
      imgPicker,SideBar
    },
    data() {
      return {
        isDisable: false,
        loading: false,
        spaceInput: false,
        categoryList: [],
        total_count: 0,
        params: [],
        imgDialog: false,
        isGetImage: true,
        current: '',
        category_id: '',
        show_batchStore: false,
        submitLoading: false,
        batchsubmitLoading:false,
        districtId:0,
        updateBatchList:[],
        shop_type_list: [],
        shop_type_list_default:[
          {shop_type_name:'未选择',shop_type_id:'-1'},
          {shop_type_name:'全部',shop_type_id:'0'},
          {shop_type_name:'怡康自营（药）店',shop_type_id:'-2'},
          {shop_type_name:'非怡康自营店',shop_type_id:'-3'}
        ],
        itemstore: 0,
        new_office_area:[],
      }
    },
    methods: {
      saveSynsc(){
        let paramsArr = {}
        paramsArr = {
          'distributor_number': this.districtId,
          'shop_type_id':this.params.shop_type_id,
          'category_id':this.category_id,
          'office_area_id':this.office_area_id,
          'office_area_pid':this.office_area_pid,
        }
        // 店铺类型和区域只能选中一个
        if(this.params.shop_type_id != -1 && this.office_area_pid){
          alert('店铺类型和区域只能选中一个!');
          return false;
        }
        if( this.params.shop_type_id == -1 && !this.office_area_pid  && this.districtId == 0){
          alert('请选择店铺!');
          return false;
        }
        saveToDistributor(paramsArr).then(response => {
          let status = response.data.data.status
          var messInfo = status ? '操作成功' : '操作失败';
          var typeMes  = status ? 'success' : 'error';
          this.$message({
            type: typeMes,
            message: messInfo
          });
        })
      },
      handleOfficeChange:function (val){
        //分离出区域id 和区域父id
        var now_office_area_pid = val[0]
        if(val.length > 1){
          var now_office_area_id = val[1]
        }else{
          var now_office_area_id = 0
        }
        this.office_area_id  = now_office_area_id
        this.office_area_pid = now_office_area_pid
      },

      toDistributor(category_id) {
        this.category_id=category_id
        this.show_rebate_sideBar = false
        // this.show_sideBar = true
        this.show_batchStore = true
        this.getBatchData()
      },
      getCategory() {
        this.loading = true
        getCategory(this.params).then(response => {
          this.categoryList = response.data.data
          this.loading = false
          this.spaceInput = false
        })
      },
      getBatchData(){
        this.skuLoading = true
        this.updateBatchList[''] = '';
        getShopTypes().then(res => {
          this.shop_type_list  = res.data.data.list
        })
        this.skuLoading = false
      },
      getOfficeArea(){
        getAreaManageList({'format_flag':true}).then(response => {
          this.params.page = 1;
          this.new_office_area =response.data.data;
        })
      } ,
      switchAuth(node, data) {
          let params = {
              'recommend': data.recommend ,
          }
          updateCategory(data.category_id,params).then(res => {
              if (res.data.data) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getCategory()
              }
          })
      },
      switchFrontendShow(node, data) {
        let params = {
          'frontend_show': data.frontend_show,
        }
        updateCategory(data.category_id, params).then(res => {
          if (res.data.data) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 2 * 1000
            })
            this.getCategory()
          }
        })
      },
      switchDisabled(node, data) {
        let params = {
          'disabled': data.disabled,
        }
        updateCategory(data.category_id, params).then(res => {
          if (res.data.data) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 2 * 1000
            })
            this.getCategory()
          }
        })
      },
      editRecommendSort(node, data) {
          let params = {
              'recommend_sort': data.recommend_sort ,
          }
          updateCategory(data.category_id,params).then(res => {
              if (res.data.data) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getCategory()
              }
          })
      },
      updateCategory() {
        for (var i = 0; i < this.categoryList.length; i++) {
          for (var a = 0; a < this.categoryList.length - 1 - i; a++) {
            if (this.categoryList[a].category_name == this.categoryList[a + 1].category_name) {
              this.$message({
                type: 'error',
                message: '同级分类名称不能相同'
              })
              return false
            }
          }
          if (!this.catNameCheck(this.categoryList[i].category_name)) {
            return false
          }
          if(this.categoryList[i].children){
            for (var j = 0; j < this.categoryList[i].children.length; j++) {
              for (var b = 0; b < this.categoryList[i].children.length - 1 - j; b++) {
                if (this.categoryList[i].children[b].category_name == this.categoryList[i].children[b + 1].category_name) {
                  this.$message({
                    type: 'error',
                    message: '同级分类名称不能相同'
                  })
                  return false
                }
              }
            }
            // if (!this.catNameCheck(this.categoryList[i].children[j].category_name)) {
            //   return false
            // }
          }
        }

        this.isDisable = true
        setTimeout(() => {
            this.isDisable = false
        }, 1000)

        console.log(this.categoryList);
        let form = JSON.stringify(this.categoryList)
        saveCategory({form: form}).then(response => {
          this.$message({
            type: 'success',
            message: '保存分类成功'
          })
          this.getCategory()
        })
      },
      deleteCategory(node, data) {
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof (data.category_id) != 'undefined') {
            deleteCategory(data.category_id).then(response => {
              this.$message({
                type: 'success',
                message: '删除分类成功'
              })
              this.getCategory()
            })
          } else {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex(d => d.category_name === data.category_name);
            children.splice(index, 1);
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      append(data, level = 0) {
        console.log(data, level)
        const newChild = {category_name: '', sort: 0, level: ++level, children: [], created: 0, image_url: ''}
        data.push(newChild)
      },
      appendTop(data) {
        const newChild = {category_name: '', sort: 0, level: 0, children: [], created: 0, image_url: ''}
        data.push(newChild)
      },
      catNameCheck(catName) {
        let catNameLength = 0
        if (catName) {
          for (var i = 0; i < catName.length; i++) {
            if (catName.charCodeAt(i) > 255) {
              catNameLength += 2;
            } else {
              catNameLength++;
            }
          }
          if (catNameLength > 50) {
            this.$message({
              type: 'error',
              message: '分类名称长度最多25个汉字或50个字符'
            })
            return false
          }
          return true
        } else {
          this.$message({
            type: 'error',
            message: '分类不能为空'
          })
          return false
        }
      },
      handleImgChange(data) {
        this.imgDialog = true
        this.isGetImage = true
        this.current = data
      },
      pickImg(data) {
        if (!this.current.parent_id || this.current.parent_id == 0) {
          const index = this.categoryList.findIndex(d => d.id === this.current.id);
          this.categoryList[index].image_url = data.url
        } else if (this.current.parent_id && this.current.level == 1) {
          const findex = this.categoryList.findIndex(d => d.id === this.current.parent_id);
          const cindex = this.categoryList[findex].children.findIndex(d => d.id === this.current.id);
          this.categoryList[findex].children[cindex].image_url = data.url
        } else {
          let findex
          let cindex
          for (var item in this.categoryList) {
            cindex = this.categoryList[item].children.findIndex(d => d.id === this.current.parent_id);
            findex = item
            if (cindex > -1) break
          }
          const tindex = this.categoryList[findex].children[cindex].children.findIndex(d => d.id === this.current.id);
          this.categoryList[findex].children[cindex].children[tindex].image_url = data.url

        }
        this.imgDialog = false
      },
      closeImgDialog() {
        this.imgDialog = false
      },
    },

    mounted() {
      this.getCategory()
      this.getOfficeArea()
    }
  };
</script>

<style scoped lang="scss">
    .custom-tree-container {
        background-color: #fff;
        min-width: 1100px;
    }

    .tree-background {
        padding-bottom: 45px;
        margin: 0px 20px;
    }

    .custom-tree-node, .custom-tree-node-title {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        /*padding-right: 8px;*/
        li {
            display: inline-block;
            text-align: center;
            width: 25%;
        }

        li:first-child {
            text-align: left;
        }

        li.category-icon {
            display: flex;
            align-items: middle;
            justify-content: center;

            span {
                height: 30px;
            }

            img {
                width: auto;
                height: 30px;
            }
        }
    }

    .custom-tree-node-title {
        font-weight: bold;
        color: #909399;
        margin: 0px 20px;

        li {
            padding: 12px 0;
        }
    }

    .add-category {
        margin-left: 25px;
        margin-top: 30px;

        span {
            cursor: pointer;
        }
    }

    .remove-category {
        margin-left: 10px;
    }

    .add-child-category {
        margin-left: 10px;
    }
</style>
<style lang="scss">
    .custom-tree-container {
        .el-tree-node__content {
            height: 45px;
            padding: 0px;
            line-height: 45px;
        }

        .el-tree > .el-tree-node {
            position: relative;

            &::after {
                position: absolute;
                height: 1px;
                left: 0;
                right: 0;
                bottom: 0;
                content: "";
                background-color: #e6e6e6;
            }
        }

        .el-tree > .el-tree-node:first-child {
            &::before {
                position: absolute;
                height: 1px;
                left: 0;
                right: 0;
                top: 0;
                content: "";
                background-color: #e6e6e6;
            }
        }
    }

    .custom-tree-node {
        input {
            border: 1px solid #ddd;
            line-height: 25px;
            padding-left: 5px;
            width: 150px;
        }
    }

</style>



// WEBPACK FOOTER //
// category.vue?6f4f5cc2